import React, { useContext, useCallback } from 'react';
import { IViewModifierContext, ViewModifierContext } from '../../viewModifierState/viewModifierContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalAssignModifierToRestaurants } from 'components/ModalWindows/ModalAssignModifierToRestaurants';
import { ModalEditNestedModGroupTemplate } from 'components/ModalWindows/ModalEditNestedModGroupTemplate';
import { ViewPortionModal } from './ViewPortionModal';

export const ModalWindows: React.FC = () => {
	const { changeTypeOfModalWindow, refetchData, refetchRestPropsData, modifierFullInfo, typeOfModalWindow } =
		useContext<IViewModifierContext>(ViewModifierContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingModifier');
	}, [changeTypeOfModalWindow]);

	const handleCloseModifierHasPortionsError = useCallback(() => {
		changeTypeOfModalWindow('errorModifierHasPortions');
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, [refetchData, changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchRestPropsData = useCallback(() => {
		refetchRestPropsData(true);
		changeTypeOfModalWindow(null);
	}, [refetchRestPropsData, changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'errorUpdatingModifier' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingModifier"
				/>
			)}
			{typeOfModalWindow === 'errorModifierHasPortions' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorModifierHasPortions"
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && (
				<ModalAssignModifierToRestaurants
					onCloseModal={handleCloseModalWithRefetchData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseModalWithError}
					modifierId={modifierFullInfo?.id || ''}
				/>
			)}
			{typeOfModalWindow === 'editNestedModGroupTemplate' && (
				<ModalEditNestedModGroupTemplate
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseModalWithRefetchRestPropsData}
					onShowError={handleCloseModalWithError}
					onShowProductHasPortionsError={handleCloseModifierHasPortionsError}
					modifierId={modifierFullInfo?.id || ''}
				/>
			)}
			{typeOfModalWindow === 'viewPortion' && <ViewPortionModal onCloseModal={handleCloseModal} />}
		</ModalWrapper>
	);
};
